export enum IDENTITY_VERIFICATION_SCREEN {
  NONE = "None",
  MESSAGE = "Message",
  Identity_Verification = "Identity Verification",
  IDENTITY_APPROVED = "Identity Approved",
  IDENTITY_FAILED = "Identity Failed",
}
